import accounts from './accounts';
import devices from './devices';
import settings from './settings';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [accounts, devices, settings]
};

export default menuItems;
